import React from "react";

import PCTemplate from "../../components/pc-template";
import DrawerBar from "../../components/drawer";

import { FloatButton } from "antd";

const Home: React.FC = () => {
  return (
    <>
      <DrawerBar />
      <PCTemplate />

      <FloatButton.BackTop />
    </>
  );
};

export default Home;
